import { Link } from "react-router-dom";
import { Briefcase, Heart, Rocket, Mail, ArrowLeft, MapPin } from "lucide-react";

const VALUES = [
  { icon: Heart, title: "We love celebrations", text: "Every booking is someone's big day. We treat it like our own." },
  { icon: Rocket, title: "Move fast, stay warm", text: "We ship quickly for vendors and families, without losing the human touch." },
  { icon: MapPin, title: "Rooted in the coast", text: "Proudly building for Kundapura, Udupi and the towns we call home." },
];

const ROLES = [
  { title: "Vendor Success Associate", type: "Full-time · Kundapura", desc: "Onboard and support local decorators, caterers and photographers." },
  { title: "Field Marketing Executive", type: "Full-time · Udupi", desc: "Grow Book My Event across coastal Karnataka, event by event." },
  { title: "Frontend Engineer (React)", type: "Remote / Hybrid", desc: "Craft delightful booking experiences on web and PWA." },
];

export default function Careers() {
  return (
    <div className="px-4 md:px-8 py-8 pb-20" data-testid="careers-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary mb-6" data-testid="careers-back">
        <ArrowLeft className="h-4 w-4" /> Back to home
      </Link>

      <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 text-primary px-4 py-1.5 text-xs font-bold uppercase tracking-wider mb-4">
        <Briefcase className="h-3.5 w-3.5" /> Careers
      </div>
      <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight max-w-2xl">
        Help us make every celebration unforgettable
      </h1>
      <p className="text-muted-foreground mt-4 max-w-2xl text-base leading-relaxed">
        Book My Event is the Udupi region's premier event marketplace. We're a small, passionate team
        connecting families with the very best decorators, DJs, caterers and photographers. If you love
        events and want to build something people genuinely celebrate with, we'd love to meet you.
      </p>

      <div className="grid sm:grid-cols-3 gap-4 mt-10">
        {VALUES.map((v) => (
          <div key={v.title} className="rounded-2xl bg-card border border-stone-200 p-5">
            <div className="h-11 w-11 rounded-xl bg-primary/10 text-primary grid place-items-center mb-3">
              <v.icon className="h-5 w-5" />
            </div>
            <p className="font-display font-bold">{v.title}</p>
            <p className="text-sm text-muted-foreground mt-1">{v.text}</p>
          </div>
        ))}
      </div>

      <h2 className="font-display font-bold text-2xl tracking-tight mt-12 mb-4">Open roles</h2>
      <div className="grid gap-3">
        {ROLES.map((r) => (
          <div
            key={r.title}
            data-testid={`role-${r.title.replace(/\s+/g, "-").toLowerCase()}`}
            className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-card border border-stone-200 rounded-2xl p-5"
          >
            <div>
              <p className="font-display font-bold text-lg">{r.title}</p>
              <p className="text-xs text-primary font-semibold uppercase tracking-wide mt-0.5">{r.type}</p>
              <p className="text-sm text-muted-foreground mt-1">{r.desc}</p>
            </div>
            <a
              href="mailto:bookmyevent.bme@gmail.com?subject=Application"
              className="shrink-0 inline-flex items-center justify-center gap-2 h-11 px-5 bg-primary text-white rounded-full text-sm font-semibold hover:bg-primary/90 transition-colors"
            >
              <Mail className="h-4 w-4" /> Apply now
            </a>
          </div>
        ))}
      </div>

      <div className="mt-12 rounded-2xl border border-stone-200 bg-accent/40 p-6 text-center">
        <p className="font-semibold">Don't see a role that fits?</p>
        <p className="text-sm text-muted-foreground mt-1">
          We're always keen to meet great people. Write to us at{" "}
          <a href="mailto:bookmyevent.bme@gmail.com" className="text-primary font-semibold">bookmyevent.bme@gmail.com</a>.
        </p>
      </div>
    </div>
  );
}
